<div class="page-padding">
  <div class="panel" style="padding: 1%;">
    <div class="search-options" style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;">
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Customer' | translate | async}}</span>
        <mat-select id="select-customer" [placeholder]="'Select Customer' | translate | async" [(ngModel)]="selectedCustomer"
                    (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl multiple>
          <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
            {{customer.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Jobsite'  | translate | async}}</span>
        <mat-select id="select-jobsite" [placeholder]="'Select Job Site' | translate | async" [(ngModel)]="selectedJobsite"
                    (selectionChange)="loadEquipmentForJobsite()" ngDefaultControl multiple>
          <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
            {{jobsite.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Machine'  | translate | async}}</span>
        <mat-select id="select-equipment-serialno" [placeholder]="'Select Machine' | translate | async"
                    [(ngModel)]="selectedEquipment" ngDefaultControl multiple>
          <mat-option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
            {{equipment.SerialNumber}} ||  {{equipment.UnitNumber}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Family'  | translate | async}}</span>
        <mat-select id="select-type" [placeholder]="'Select Family' | translate | async" [(ngModel)]="selectedFamily" (selectionChange)="loadModelList()"
                    ngDefaultControl multiple>
          <mat-option [value]="type.Id" *ngFor="let type of  _favouriteDialogService.availableFamilyList">
            {{type.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Model'  | translate | async}}</span>
        <mat-select id="select-model" [placeholder]="'Select Model' | translate | async" [(ngModel)]="selectedModel" ngDefaultControl
                    multiple>
          <mat-option [value]="model.Id" *ngFor="let model of modelList">
            {{model.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="search-control header-form-full-width">
        <div class="flex flex--align-center" style="display: flex; justify-content: flex-end;">
          <a class="button" (click)="ResetFields();"><span class="button__text">{{'Reset'  | translate | async}}</span></a>&nbsp;&nbsp;
          <a class="button button--primary" (click)="submitSelection()">
            <i class="material-icons button__icon">search</i><span class="button__text">{{'Perform Search' | translate | async}}</span>
          </a>
        </div>
      </div>
    </div>


  </div>
  <div class="panel" style="display: flex; flex-direction: column;">
    <div class="search-pan">
      <div style="float: left;">
        <span class="tabheader">{{'Inspection Events' | translate | async}}</span>
      </div>
      <div style="float:right;">
        <a class="button button--primary" (click)="getJSON()" title="Click to get filtered data in JSON format.">
          <i class="material-icons button__icon">download</i><span class="button__text">{{'JSON'  | translate | async}}</span>
        </a>
        &nbsp;&nbsp;
        <a class="button button--primary" (click)="getCSV()" title="Click to get filtered data in CSV format.">
          <i class="material-icons button__icon">download</i><span class="button__text">{{'CSV Export'  | translate | async}}</span>
        </a>
      </div>
    </div>
    <div style="padding: 1%; background-color: #F5F8FB;">
      <div style="margin-left: 39%; min-height:150px;" *ngIf="loading">
        <mat-spinner> </mat-spinner>
      </div>
      <div *ngIf="!loading">
        <table class="table table--full-width table--striped table--hover">
          <thead>
            <tr>
              <th>{{'Customer' | translate | async}}</th>
              <th>{{'Job Site' | translate | async}}</th>
              <th>{{'Models' | translate | async}}</th>
              <th>{{'Unit #' | translate | async}}</th>
              <th>{{'Inspection Date' | translate | async}}</th>
              <th>{{'Risk Rating' | translate | async}}</th>
              <!--<th>SAP Work Order</th>-->
              <th>{{'Inspection Comments' | translate | async}}</th>
              <th>{{'Recommended Actions' | translate | async}}</th>
              <th>{{'Your Inspection ID' | translate | async}}</th>
              <th>{{'Inspection Type' | translate | async}}</th>
              <th>{{'Meter Read / SMU'  | translate | async}}</th>
              <th style="width: 15%;">{{'Measured Data Part Wear % per Component' | translate | async}}</th>
              <th>{{'Bush Turned Left' | translate | async}}</th>
              <th>{{'Bush Turned Right' | translate | async}}</th>
              <th style="width: 10%;">{{'Actions' | translate | async}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="noRecords">
              <td>
                <div style="display: block;font-size: larger;font-weight: bolder;">
                  <span style="color: red; font-style: italic;">{{'No Data Found - please can reset your selection and try again.'  | translate | async}}</span>
                </div>
              </td>
            </tr>
            <ng-container *ngFor="let forms of PerformResult">
              <tr>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.customer}}</td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.jobsite}}</td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.model}}</td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.unitNumber}}</td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.inspectionDate | date : 'dd MMM yyyy'}}</td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.riskRating}}</td>
                <td class=" columncell" title="{{forms.inspectionComments}}">{{forms.inspectionComments}}</td>
                <td class=" columncell">
                  <div style="display: flex; flex-direction: column;">
                    <span *ngFor="let recom of getArrayFromStirng(forms.recommendedActions,'|')">{{recom}}</span>
                  </div>
                </td>
                <td class=" columncell"><a style="cursor:pointer;" title="Click to print PDF." (click)="printPDF(forms.printPdf)" href="javascript:void(0);" *ngIf="forms.printPdf != ''">{{forms.inspectionId}}</a><span *ngIf="forms.printPdf == ''">{{forms.inspectionId}}</span></td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.inspectionType}}</td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.smu}}</td>
                <td class=" columncell" style="width: 15%;">
                  <div style="display: flex; flex-direction: column;">
                    <span *ngFor="let com of getArrayFromStirng(forms.measuredDataPer,'|')">{{com}}</span>
                  </div>
                </td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.bushTurnLeft}}</td>
                <td class=" columncell" style="cursor: pointer;" title="Click to get inspection detail in JSON format." (click)="rowClick(forms.customerId, forms.inspectionId)">{{forms.bushTurnRight}}</td>
                <td class=" columncell" style="width: 10%;">
                  <div style="display: flex; flex-direction: column;">
                    <span *ngFor="let com of getArrayFromStirng(forms.actions,',')">{{com}}</span>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
